import Overview from './overview.vue';
import FullIndex from '@rebuild/materials/shared/investment_activity/FullIndex.vue';
import RoadshowIndex from '@rebuild/materials/shared/investment_activity/RoadshowIndex.vue';
import OfflineIndex from '@rebuild/materials/shared/investment_activity/OfflineIndex.vue';
import ResearchIndex from '@rebuild/materials/shared/investment_activity/ResearchIndex.vue';



export const componentMap = {
	overview: Overview,
	full: FullIndex,
	roadshow: RoadshowIndex,
	offline: OfflineIndex,
	research: ResearchIndex
};
